module.exports = __webpack_public_path__ + "static/media/list-view.593bc6ea.svg";